/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SolutionItemAdditionalFieldType {
    Text = '0',
    DateTime = 1,
}
